import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';
import { Badge } from '../ui/badge';
import { format } from 'date-fns';

const planColors = {
  Starter: 'bg-blue-500/10 text-blue-400 border-blue-500/30',
  Pro: 'bg-purple-500/10 text-purple-400 border-purple-500/30',
  Elite: 'bg-amber-500/10 text-amber-400 border-amber-500/30',
};

const statusColors = {
  Active: 'bg-[#D4AF37]/10 text-[#D4AF37] border-[#D4AF37]/30',
  Expired: 'bg-red-500/10 text-red-400 border-red-500/30',
};

export function MemberTable({ members, limit }) {
  const displayMembers = limit ? members?.slice(0, limit) : members;

  return (
    <div 
      className="bg-zinc-900/50 border border-white/10 rounded-sm overflow-hidden"
      data-testid="member-table"
    >
      <div className="p-6 border-b border-white/10">
        <h3 className="text-lg font-semibold text-white tracking-tight">Members</h3>
        <p className="text-xs text-zinc-500 mt-1">Overview of gym members and their plans</p>
      </div>
      
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="border-white/10 hover:bg-transparent">
              <TableHead className="text-xs font-bold uppercase tracking-[0.1em] text-zinc-500 py-4">Name</TableHead>
              <TableHead className="text-xs font-bold uppercase tracking-[0.1em] text-zinc-500 py-4">Plan Type</TableHead>
              <TableHead className="text-xs font-bold uppercase tracking-[0.1em] text-zinc-500 py-4">Join Date</TableHead>
              <TableHead className="text-xs font-bold uppercase tracking-[0.1em] text-zinc-500 py-4">Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {displayMembers && displayMembers.length > 0 ? (
              displayMembers.map((member, index) => (
                <TableRow 
                  key={member.id || index}
                  className="border-white/5 hover:bg-zinc-900/50 transition-colors"
                  data-testid={`member-row-${index}`}
                >
                  <TableCell className="py-4">
                    <div className="flex items-center gap-3">
                      <img
                        src={member.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(member.name)}&background=18181B&color=D4AF37`}
                        alt={member.name}
                        className="w-9 h-9 rounded-sm object-cover border border-white/10"
                      />
                      <div>
                        <p className="text-sm font-medium text-white">{member.name}</p>
                        <p className="text-xs text-zinc-500">{member.email}</p>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className="py-4">
                    <Badge 
                      variant="outline" 
                      className={`rounded-sm text-xs font-medium ${planColors[member.plan_type] || planColors.Starter}`}
                    >
                      {member.plan_type}
                    </Badge>
                  </TableCell>
                  <TableCell className="py-4">
                    <span className="text-sm text-zinc-400">
                      {format(new Date(member.join_date), 'MMM d, yyyy')}
                    </span>
                  </TableCell>
                  <TableCell className="py-4">
                    <Badge 
                      variant="outline" 
                      className={`rounded-sm text-xs font-medium ${statusColors[member.status] || statusColors.Expired}`}
                    >
                      {member.status}
                    </Badge>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} className="text-center py-8 text-zinc-500 text-sm">
                  No members found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}

